import type { MoneyScale } from './moneyScale';
import { DEFAULT_MONEY_SCALE } from './moneyScale';

/** Half-up al número de decimales de la moneda. */
export function roundMoney(value: number, scale: MoneyScale = DEFAULT_MONEY_SCALE): number {
  if (!Number.isFinite(value)) return 0;
  const fd = Math.max(0, Math.min(8, scale.fractionDigits));
  const factor = 10 ** fd;
  const sign = value < 0 ? -1 : 1;
  const abs = Math.abs(value);
  const scaled = abs * factor;
  const rounded = Math.floor(scaled + 0.5);
  return (sign * rounded) / factor;
}

export function toMinorUnits(value: number, scale: MoneyScale = DEFAULT_MONEY_SCALE): number {
  const fd = Math.max(0, Math.min(8, scale.fractionDigits));
  const factor = 10 ** fd;
  return Math.round(roundMoney(value, scale) * factor);
}

export function fromMinorUnits(minor: number, scale: MoneyScale = DEFAULT_MONEY_SCALE): number {
  const fd = Math.max(0, Math.min(8, scale.fractionDigits));
  const factor = 10 ** fd;
  return minor / factor;
}

export function minorUnitsEqual(a: number, b: number, scale: MoneyScale = DEFAULT_MONEY_SCALE): boolean {
  return toMinorUnits(a, scale) === toMinorUnits(b, scale);
}

export function compareMinorUnits(
  a: number,
  b: number,
  scale: MoneyScale = DEFAULT_MONEY_SCALE,
): number {
  return toMinorUnits(a, scale) - toMinorUnits(b, scale);
}
